import React from 'react';
import styles from './summary.module.scss';
import { SummaryType, SummaryStep } from '~/types/estimates';
import { digitFormatter } from '~/utils';
import {
  formatSummaryStepQuantityDisplay,
  groupSummarySteps,
  type SummaryStepGroup,
} from '~/utils/summary-groups';

const Summary = ({
  summary,
  groupSteps = groupSummarySteps,
}:{
  summary: SummaryType,
  groupSteps?: (steps: SummaryStep[]) => SummaryStepGroup[],
}) => {
  const groups = groupSteps(summary.steps);

  return (
    <div id="summary" className={styles.summary}>
      <hr />
      <h4>Résumé de la phase</h4>
      <div className={`${styles.row} ${styles.label}`}>
        <p>Désignation</p>
        <p>Quantité</p>
        <p>Pu net</p>
        <p>Total</p>
      </div>
      {groups.map((group) => (
        <React.Fragment key={group.title || group.steps[0]?.value || 'standard'}>
          {group.title && (
            <div className={`${styles.row} ${styles.sectionTitle}`}>
              <p>{group.title}</p>
            </div>
          )}
          {group.steps.map((s) => (
            <div
              key={`${s.value}-${s.label}`}
              className={styles.row}
            >
              <p>{s.label}</p>
              <p>{formatSummaryStepQuantityDisplay(s)}</p>
              <p>{digitFormatter.format(s.unitPrice.value)} {s.unitPrice.unit || '€'}</p>
              <p>{digitFormatter.format(s.total)} €</p>
            </div>
          ))}
        </React.Fragment>
      ))}

      <div className={styles.total}>
        <div className={styles.count}>
          <p>Total HT</p><p><span>{digitFormatter.format(summary.totalHT)} €</span></p>
        </div>
        <div className={styles.count}>
          <p>TVA applicable 20 %</p><p>{digitFormatter.format(summary.tva)} €</p>
        </div>
        <div className={styles.count}>
          <p>Total TTC</p><p><span>{digitFormatter.format(summary.totalTTC)} €</span></p>
        </div>
      </div>
      <hr />
    </div>
  );
};

export default Summary;
